import React from "react";
import amaxLogo from "../images/amaxLogo.png";
import { Link } from "react-router-dom";

export const Step2 = () => {
  return (
    <div
      className={`p-[30px_20px_40px] bg-custom-image-2 h-dvh overflow-hidden`}
    >
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <div className="size-[96px] lg:size-[166px] ml-auto">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </div>
        <div>
          <div className="w-full max-w-2xl mb-[100px]">
            <p className="text-white text-[22px] font-apercu font-normal">
              Creating products that are simple to use and individually designed
              for Athletes.{" "}
            </p>
            <p className="text-white text-[22px] font-normal mt-6">
              We Build <span className="font-bold italic">FAST</span> Athletes.{" "}
            </p>
          </div>
          <div className="w-full max-w-2xl flex flex-row gap-[14px]">
            <Link to="/signupinterface" className="w-1/2">
              <button className="text-base text-white font-semibold w-full transition-all duration-300 rounded-[75px] hover:bg-white hover:text-black border border-white flex justify-center items-center px-2 py-[18px]">
                SIGN IN
              </button>
            </Link>
            <Link to="/signupinfo" className="w-1/2">
              <button className="text-base font-semibold w-full bg-white transition-all duration-300 rounded-[75px] border border-white flex justify-center items-center px-2 py-[18px] hover:text-white hover:bg-transparent">
                JOIN US
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
